import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup
} from 'reactstrap';

export default class extends Component {
  onConfirm = e => {
    e.preventDefault();

    this.props.onConfirm();
  };

  render() {
    let { children, labelText, headerText, onConfirm, ...otherProps } = this.props;

    return (
      <Modal {...otherProps} backdrop keyboard autoFocus>
        <form className="modal-confirmation" onSubmit={this.onConfirm}>
          {!!headerText && <ModalHeader>{headerText}</ModalHeader>}
          <ModalBody>
            {children}
            {!!labelText && <FormGroup className="col-sm-12">{labelText}</FormGroup>}
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="success">
              Confirma
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Confirm.js